import Vue from "vue";
import { Component } from "vuety";
import "loadingspinner.css";

const templateElement = "v-tmpl-spinner";

@Component({
    template: document.getElementById(templateElement) ? "#" + templateElement
    : require("./loadingspinner.html")
    })
export class LoadingSpinner extends Vue {

}



// WEBPACK FOOTER //
// ./src/components/loadingspinner.ts